import { EmptyState } from "@modules/slides-library/shared";
import { SearchSlidesSkeleton } from "@modules/slides-library/shared/components/skeleton/slides-library-content-skeleton";
import { useSlidesLibraryStoreShallow } from "@modules/slides-library/shared/store";
import type { TSavedSlide } from "@/shared/types";
import { SingleSlide } from "./single-slide";

export const SearchResults = ({ data }: { data: TSavedSlide[] }) => {
  const { isSearching, search } = useSlidesLibraryStoreShallow((s) => ({
    isSearching: s.isSearching,
    search: s.search,
  }));
  return (
    <div>
      <div className="tw-flex tw-h-[52px] tw-items-start tw-justify-between tw-self-stretch tw-bg-white tw-py-4">
        <div className="tw-flex tw-flex-1 tw-items-start tw-px-6">
          <div className="tw-flex tw-flex-1 tw-items-center tw-gap-2">
            <span className="tw-font-sans tw-text-sm tw-font-medium tw-leading-5 tw-text-blue">
              {isSearching ? (
                <span className="tw-block tw-h-5">
                  <span className="tw-block tw-h-5 tw-w-36 tw-animate-pulse tw-rounded tw-bg-blue-100" />
                </span>
              ) : (
                `Search results for "${search}"`
              )}
            </span>
          </div>
        </div>
      </div>
      {isSearching ? (
        <SearchSlidesSkeleton count={6} />
      ) : data.length === 0 ? (
        <EmptyState title="No results found" />
      ) : (
        <div className="tw-flex tw-flex-wrap tw-gap-2 tw-px-6 tw-pb-4">
          {data.map((slide) => (
            <SingleSlide key={slide._id} slide={slide} />
          ))}
        </div>
      )}
    </div>
  );
};
